import * as z from "zod";

export const TransportDeviceValidationSchema = z.object({
  name: z.string().min(1, { message: "validation:required" }),
  // Select values are strings, converted to deviceTypeId on submit
  deviceTypeId: z.string().min(1, { message: "validation:required" }),
  hasBuiltInScale: z.boolean(),
});

export type TransportDeviceFormInput = z.infer<typeof TransportDeviceValidationSchema>;
